import { useEffect, useState } from 'react';
import AUX from '../../../hoc/Aux_';
import { Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getSocketAPI } from '../../../Constant';
import { io } from 'socket.io-client';
import {
  getRealTime,
  getRealTimeMember,
  getRealTimeProject,
} from '../../../redux/MainAction';
import AppsModals from '../Monitoring/Activity/AppsModals';
import AppsUsages from '../Monitoring/Activity/AppUsages';
import MapModal from '../Monitoring/Activity/MapModal';
import Select from 'react-select';

const RealTimeList = () => {
  const dispatch = useDispatch();
  const real = useSelector((state) => state?.Webtracker?.realTime);
  const memb = useSelector((state) => state?.Webtracker?.realTimeMember);
  const prj = useSelector((state) => state?.Webtracker?.realTimePoject);
  const authToken = localStorage.getItem('loged_In_auth');
  const ownerId = localStorage.getItem('userId');
  const [socket, setSocket] = useState(null);

  const [filters, setFilters] = useState({
    employeeIds: [],
    projectIds: '',
    statuses: '',
  });

  const [showReset, setShowReset] = useState(false);
  const [appsData, setAppsData] = useState([]);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isAppUsageOpen, setIsAppUsageOpen] = useState(false);

  const onChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  // useEffect(() => {
  //   getList();
  // }, []);

  const getList = () => {
    const payload = {};

    if (filters?.employeeIds?.length > 0) {
      payload.employeeIds = filters.employeeIds;
    }

    if (filters?.projectIds !== '') {
      payload.projectIds = [filters.projectIds];
    }
    if (filters?.statuses !== '') {
      payload.statuses = [filters.statuses];
    }

    dispatch(getRealTime(payload));
  };

  const handleEmployeeChange = (selectedOptions) => {
    const selectedIds = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilters((prevFilters) => ({
      ...prevFilters,
      employeeIds: selectedIds,
    }));
  };

  const employeeOptions =
    memb?.rows?.map((member) => ({
      value: member.employeeId,
      label: `${member?.user?.firstName} ${member?.user?.lastName}`,
    })) || [];

  const handleApply = (e) => {
    e.preventDefault();
    // const payload = {
    //   offset: 0,
    //   limit: 10,
    // };

    // if (filters?.employeeIds?.length > 0) {
    //   payload.employeeIds = filters.employeeIds;
    // }

    // if (filters?.projectIds !== '') {
    //   payload.projectIds = [filters.projectIds];
    // }
    // if (filters?.statuses !== '') {
    //   payload.statuses = [filters.statuses];
    // }
    // dispatch(getRealTime(payload));
    getList();
    setShowReset(true);
  };

  const handleReset = (e) => {
    e.preventDefault();
    setFilters({
      employeeIds: [],
      projectIds: '',
      statuses: '',
    });
    dispatch(getRealTime());
    setShowReset(false);
  };

  useEffect(() => {
    if (ownerId && authToken) {
      const payload = {};

      if (filters?.employeeIds?.length > 0) {
        payload.employeeIds = filters.employeeIds;
      }

      if (filters?.projectIds !== '') {
        payload.projectIds = [filters.projectIds];
      }
      if (filters?.statuses !== '') {
        payload.statuses = [filters.statuses];
      }

      dispatch(getRealTime(payload));

      // const socketInstance = io(
      //   `${getSocketAPI()}/user?token=${authToken}&ownerId=${ownerId}`
      // );

      // socketInstance.on('connect', () => {
      //   console.log('Socket connected:', socket?.id);
      // });

      // setSocket(socketInstance);
      // socketInstance.on('connect_error', (error) => {
      //   console.error('Socket connection error:', error, socketInstance);
      // });

      // socketInstance.on('/employee/online', (response) => {
      //   if (response.status) {
      //     dispatch(getRealTime(payload));
      //   }
      // });

      // socketInstance.on('/employee/offline', (response) => {
      //   if (response.status) {
      //     dispatch(getRealTime(payload));
      //   }
      // });
      // socketInstance.on('/employee/project/task/activity/start', (response) => {
      //   if (response?.success) {
      //     dispatch(getRealTime(payload));
      //   }
      // });
      // socketInstance.on(
      //   '/employee/project/task/activity/update',
      //   (response) => {
      //     if (response?.success) {
      //       dispatch(getRealTime(payload));
      //     }
      //   }
      // );
      // socketInstance.on('/employee/project/task/activity/end', (response) => {
      //   if (response?.success) {
      //     dispatch(getRealTime(payload));
      //   }
      // });

      // return () => {
      //   socketInstance.disconnect();
      // };
    }
  }, [authToken, ownerId]);

  useEffect(() => {
    dispatch(getRealTimeMember());
    dispatch(getRealTimeProject());
  }, []);

  const formatLastSeen = (lastSeenTimeInSeconds) => {
    if (lastSeenTimeInSeconds <= 0) return null;

    const hours = Math.floor(lastSeenTimeInSeconds / 3600);
    const minutes = Math.floor((lastSeenTimeInSeconds % 3600) / 60);

    if (hours > 0) {
      return `Last seen${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
    } else if (minutes > 0) {
      return `Last seen <div>${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago</div>`;
    } else {
      return `Last seen <div>just now</div>`;
    }
  };

  const toggleModalEdit = (data) => {
    const allData = {
      employee: data?.user,
      projectTask: data?.projectTask,
      appWebsites: data?.employeeRealtimeProjectTaskActivity?.appWebsites,
      appWebsiteDetails:
        data?.employeeRealtimeProjectTaskActivity?.appWebsiteDetails,
      description: data?.employeeRealtimeProjectTaskActivity?.description,
    };
    setIsEditOpen(!isEditOpen);
    setAppsData(allData);
  };

  const toggleModalAppUsages = (data) => {
    const allData = {
      employee: data?.user,
      projectTask: data?.projectTask,
      description: data?.employeeRealtimeProjectTaskActivity?.description,
      appWebsiteDetailsUsage:
        data?.employeeRealtimeProjectTaskActivity?.appWebsiteDetailsUsage,
    };
    setIsAppUsageOpen(!isAppUsageOpen);
    setAppsData(allData);
  };

  useEffect(() => {
    if (isEditOpen) {
      const realtimeData = real?.list?.find(
        (realData) => realData?.user?.id === appsData?.employee?.id
      );
      const realTimeAppsData = {
        employee: realtimeData?.user,
        projectTask: realtimeData?.projectTask,
        realTimeId: realtimeData?.employeeRealtimeProjectTaskActivity?.id,
        appWebsites:
          realtimeData?.employeeRealtimeProjectTaskActivity?.appWebsites,
        appWebsiteDetails:
          realtimeData?.employeeRealtimeProjectTaskActivity?.appWebsiteDetails,
        description:
          realtimeData?.employeeRealtimeProjectTaskActivity?.description,
      };
      setAppsData(realTimeAppsData);
    }
  }, [isEditOpen, real]);

  useEffect(() => {
    if (isAppUsageOpen) {
      const realtimeData = real?.list?.find(
        (realData) => realData?.user?.id === appsData?.employee?.id
      );
      const realTimeAppsData = {
        employee: realtimeData?.user,
        projectTask: realtimeData?.projectTask,
        realTimeId: realtimeData?.employeeRealtimeProjectTaskActivity?.id,
        description:
          realtimeData?.employeeRealtimeProjectTaskActivity?.description,
        appWebsiteDetailsUsage:
          realtimeData?.employeeRealtimeProjectTaskActivity
            ?.appWebsiteDetailsUsage,
      };
      setAppsData(realTimeAppsData);
    }
  }, [isAppUsageOpen, real]);

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-3">
                  <div className="card real_Time m-b-20">
                    <div className="d-flex justify-content-start align-items-center card-body mb-2">
                      <span className="d-flex justify-content-start align-items-center user_border">
                        <i className="mdi mdi-account-multiple font-40 text-info text-center"></i>
                      </span>
                      <div className="col-md-8 ml-4 mt-1">
                        <span className="font-16 ">Numbers of members</span>
                        <p className=" text-muted font-15">
                          {real?.summary?.memberCount}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 ">
                  <div className="card real_Time m-b-20">
                    <div className="d-flex justify-content-start align-items-center card-body mb-2">
                      <span className="d-flex justify-content-start align-items-center user_border">
                        <i className="mdi mdi-clock font-40 text-primary text-center"></i>
                      </span>
                      <div className="d-flex justify-content-between col-9 ml-4 mt-1">
                        <div>
                          <span className="font-14 ">Working Now</span>
                          <p className=" text-muted font-15">
                            {real?.summary?.workingNowCount}
                          </p>
                        </div>
                        <div>
                          <span className="font-14 ">Offline</span>
                          <p className=" text-muted font-15">
                            {real?.summary?.offlineCount}
                          </p>
                        </div>
                        <div>
                          <span className="font-14 ">Absent</span>
                          <p className=" text-muted font-15">
                            {real?.summary?.absentCount}
                          </p>
                        </div>
                        <div>
                          <span className="font-14 ">On Leave</span>
                          <p className=" text-muted font-15">
                            {real?.summary?.onLeaveCount}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-3">
                  <div className="card real_Time m-b-20">
                    <div className="d-flex justify-content-start align-items-center card-body mb-2">
                      <span className="d-flex justify-content-start align-items-center user_border">
                        <i className=" mdi mdi-trending-down font-40 text-danger text-center"></i>
                      </span>
                      <div className="col-md-8 ml-4 mt-1">
                        <span className="font-16 ">
                          Currently non-productive
                        </span>
                        <p className=" text-muted font-15">
                          {real?.summary?.currentlyNonProductiveCount}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card m-b-20">
                <div className="d-flex justify-content-start align-items-center m-2">
                  {/* <div
                    className="d-flex justify-content-start align-items-center"
                    style={{ gap: '10px' }}
                  >
                    <div className="fillSelect">
                      <i className="mdi mdi-account-multiple-outline font-20 fillIcon"></i>
                      <select
                        className="form-control font-14"
                        name="employeeIds"
                        value={filters?.employeeIds}
                        onChange={onChangeFilter}
                      >
                        <option value="">All Members</option>
                        {memb?.rows?.map((mems, idx) => (
                          <option key={idx} value={mems?.employeeId}>
                            {mems?.user?.firstName} {mems?.user?.lastName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="fillSelect">
                      <i className="mdi mdi-briefcase font-20 fillIcon"></i>
                      <select
                        className="form-control font-14"
                        name="projectIds"
                        value={filters?.projectIds}
                        onChange={onChangeFilter}
                      >
                        <option value="">All Projects</option>
                        {prj?.rows?.map((mems, idx) => (
                          <option key={idx} value={mems?.id}>
                            {mems?.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="fillSelect">
                      <select
                        className="form-control font-14"
                        name="statuses"
                        value={filters?.statuses}
                        onChange={onChangeFilter}
                      >
                        <option value="">All Status</option>
                        <option value="ONLINE">Online</option>
                        <option value="OFFLINE">Offline</option>
                        <option value="ON-LEAVE">On-Leave</option>
                        <option value="ABSENT">Absent</option>
                      </select>
                    </div>
                    <Button
                      className="d-flex align-items-center justify-content-center"
                      style={{ padding: '6px 14px' }}
                      size="sm"
                      color="primary"
                      onClick={handleApply}
                    >
                      <i className="ion-ios7-search font-20"></i>
                    </Button>
                    {showReset ? (
                      <Button
                        className="d-flex align-items-center justify-content-center"
                        style={{ padding: '6px 13px' }}
                        size="sm"
                        color="danger"
                        onClick={handleReset}
                      >
                        <i className="mdi mdi-close font-20"></i>
                      </Button>
                    ) : (
                      ''
                    )}
                  </div> */}

                  {/* New one */}
                  <div
                    className="d-flex justify-content-start align-items-start"
                    style={{ gap: '10px' }}
                  >
                    <p className="text-muted mt-2 text-nowrap">Filter by :</p>

                    <div className="mb-3">
                      <div className="d-flex mb-2">
                        <div className="fillSelect">
                          <i className="mdi mdi-briefcase font-20 fillIcon"></i>
                          <select
                            className="form-control font-14"
                            name="projectIds"
                            value={filters?.projectIds}
                            onChange={onChangeFilter}
                          >
                            <option value="">All Projects</option>
                            {prj?.rows?.map((mems, idx) => (
                              <option key={idx} value={mems?.id}>
                                {mems?.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="fillSelect">
                          {/* <i className="mdi mdi-briefcase font-20 fillIcon"></i> */}
                          <select
                            className="form-control font-14"
                            name="statuses"
                            value={filters?.statuses}
                            onChange={onChangeFilter}
                          >
                            <option value="">All Status</option>
                            <option value="ONLINE">Online</option>
                            <option value="OFFLINE">Offline</option>
                            <option value="ON-LEAVE">On-Leave</option>
                            <option value="ABSENT">Absent</option>
                          </select>
                        </div>
                      </div>

                      <div
                        className="d-flex align-items-start"
                        style={{ gap: '0.8rem' }}
                      >
                        <div className="fillSelect">
                          <i className="mdi mdi-account-multiple-outline font-20 fillIcon"></i>
                          <Select
                            isMulti
                            value={employeeOptions.filter((option) =>
                              filters.employeeIds.includes(option.value)
                            )}
                            onChange={handleEmployeeChange}
                            options={employeeOptions}
                            placeholder="All Members"
                            className="react-select-container"
                            classNamePrefix="react-select"
                            isClearable
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                minHeight: '35px',
                                height: '35px',
                                fontSize: '14px',
                                minWidth: '200px',
                                minWidth: '260px',
                                border: '1px solid #ced4da',
                              }),
                              valueContainer: (provided) => ({
                                ...provided,
                                height: '33px',
                                padding: '0 4px',
                                overflowY: 'auto',
                              }),
                              indicatorsContainer: (provided) => ({
                                ...provided,
                                height: '33px',
                              }),
                              multiValue: (provided) => ({
                                ...provided,
                                backgroundColor: '#e9ecef',
                              }),
                              multiValueLabel: (provided) => ({
                                ...provided,
                                fontSize: '12px',
                              }),
                              indicatorsContainer: (provided) => ({
                                ...provided,
                                height: '34px',
                                padding: '0 4px',
                              }),
                            }}
                          />
                        </div>

                        <div className="d-flex" style={{ gap: '10px' }}>
                          <Button
                            className="d-flex align-items-center justify-content-center"
                            style={{ padding: '6px 14px' }}
                            size="sm"
                            color="primary"
                            onClick={handleApply}
                          >
                            <i className="ion-ios7-search font-20"></i>
                          </Button>

                          {showReset ? (
                            <Button
                              className="d-flex align-items-center justify-content-center"
                              style={{ padding: '6px 13px' }}
                              size="sm"
                              color="danger"
                              onClick={handleReset}
                            >
                              <i className="mdi mdi-close font-20"></i>
                            </Button>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div style={{ overflow: 'auto' }}>
                    <table
                      id="datatable"
                      className="table dt-responsive nowrap table-vertical"
                      width="100%"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th className="text-nowrap">Member</th>
                          <th className="text-nowrap">Project</th>
                          <th className="text-nowrap">Task</th>
                          <th className="text-nowrap">Employee's Timezone</th>
                          {/* <th className="text-center">Location</th> */}
                          <th className="text-nowrap">Tracker</th>
                          {/* <th className="text-nowrap text-center">Details</th> */}
                          <th className="text-nowrap text-center">Status</th>
                          {/* <th
                            className="text-nowrap"
                            style={{ minWidth: '25vw' }}
                          >
                            Apps & Websites
                          </th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(real?.list) && real.list.length > 0 ? (
                          real.list.map((acts, idx) => (
                            <tr key={idx}>
                              <td className="text-nowrap">
                                {acts?.user?.firstName || 'N/A'}{' '}
                                {acts?.user?.lastName || ''}
                              </td>
                              <td className="text-nowrap">
                                {acts?.projectTask?.project?.name || 'N/A'}
                              </td>
                              <td className="text-nowrap">
                                <span style={{ cursor: 'pointer' }}>
                                  {acts?.projectTask?.name || 'N/A'}
                                </span>
                              </td>
                              <td className="text-nowrap">
                                {acts?.employeeRealtimeProjectTaskActivity
                                  ?.timezone || 'N/A'}
                              </td>
                              {/* <td>
                                <MapModal
                                  acts={{
                                    longitude:
                                      acts?.employeeRealtimeProjectTaskActivity
                                        ?.longitude,
                                    latitude:
                                      acts?.employeeRealtimeProjectTaskActivity
                                        ?.latitude,
                                    city: acts
                                      ?.employeeRealtimeProjectTaskActivity
                                      ?.city,
                                  }}
                                />
                              </td> */}
                              <td className="text-nowrap">
                                {acts?.employeeRealtimeProjectTaskActivity
                                  ?.method === 'DESKTOP-APP'
                                  ? 'Desktop App'
                                  : acts?.employeeRealtimeProjectTaskActivity
                                      ?.method || 'N/A'}
                              </td>
                              {/* <td className="text-center">
                                <span>
                                  <i
                                    className={`fa fa-eye font-20 ${acts?.employeeRealtimeProjectTaskActivity ? '' : 'text-muted'}`}
                                    title={
                                      acts?.employeeRealtimeProjectTaskActivity
                                        ? 'View Activity Details'
                                        : 'Tracking not started yet'
                                    }
                                    style={{
                                      cursor:
                                        acts?.employeeRealtimeProjectTaskActivity
                                          ? 'pointer'
                                          : 'not-allowed',
                                    }}
                                    onClick={() =>
                                      !acts?.employeeRealtimeProjectTaskActivity ||
                                      toggleModalEdit(acts)
                                    }
                                  ></i>

                                  <i
                                    className={`fa fa-bar-chart-o ml-2 font-20 ${acts?.employeeRealtimeProjectTaskActivity ? '' : 'text-muted'}`}
                                    title={
                                      acts?.employeeRealtimeProjectTaskActivity
                                        ? 'View App usage'
                                        : 'Not avaialable yet'
                                    }
                                    style={{
                                      cursor:
                                        acts?.employeeRealtimeProjectTaskActivity
                                          ? 'pointer'
                                          : 'not-allowed',
                                    }}
                                    onClick={() =>
                                      !acts?.employeeRealtimeProjectTaskActivity ||
                                      toggleModalAppUsages(acts)
                                    }
                                  ></i>
                                </span>
                              </td> */}

                              <td className="text-nowrap text-center">
                                {acts?.employeeRealtimeProjectTaskActivity
                                  ?.speed ? (
                                  <div className="small mb-1">
                                    {(
                                      +acts?.employeeRealtimeProjectTaskActivity
                                        ?.speed / 1000000
                                    ).toFixed(2)}{' '}
                                    Mbps
                                  </div>
                                ) : null}
                                <span
                                  className={
                                    acts?.status === 'ONLINE'
                                      ? 'rl_status bg-success'
                                      : acts?.status === 'OFFLINE'
                                        ? 'rl_status bg-warning'
                                        : acts?.status === 'ABSENT'
                                          ? 'rl_status bg-info'
                                          : 'rl_status bg-purple'
                                  }
                                >
                                  {acts?.status === 'ONLINE'
                                    ? 'Online'
                                    : acts?.status === 'OFFLINE'
                                      ? 'Offline'
                                      : acts?.status === 'ABSENT'
                                        ? 'Absent'
                                        : 'On Leave' || 'N/A'}
                                </span>
                                <div
                                  className="small mt-1"
                                  style={{ lineHeight: 1 }}
                                  dangerouslySetInnerHTML={{
                                    __html: formatLastSeen(
                                      acts?.lastSeenTimeInSeconds
                                    ),
                                  }}
                                />
                              </td>

                              {/* <td
                                className=""
                                style={{ lineHeight: '1.2', fontSize: '14px' }}
                              >
                                {(acts?.employeeRealtimeProjectTaskActivity
                                  ?.appWebsites &&
                                  Array.isArray(
                                    acts?.employeeRealtimeProjectTaskActivity
                                      ?.appWebsites
                                  ) &&
                                  acts?.employeeRealtimeProjectTaskActivity?.appWebsites?.join(
                                    ', '
                                  )) || (
                                  <div className="text-muted">
                                    Tracking not started yet.
                                  </div>
                                )}
                              </td> */}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" style={{ textAlign: 'center' }}>
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AppsModals open={isEditOpen} onClose={toggleModalEdit} ID={appsData} />
      <AppsUsages
        open={isAppUsageOpen}
        onClose={toggleModalAppUsages}
        ID={appsData}
      />
    </AUX>
  );
};

export default RealTimeList;
